import { useTranslation } from "react-i18next";
import { UseFormGetValues, UseFormRegister, UseFormSetValue } from "react-hook-form";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { GetExtraWorkAgreementQueryResponse } from "api/generatedApi";
import { InputContainer } from "shared/styles/input-container-style";
import { ExtraWorkAgreementFormData } from "../hooks/use-input-validation";
import { Box, Checkbox } from "@mui/material";
import { useEffect, useState } from "react";
// extraWorkAgreementNumber is known as "reference nummer" in the UI
interface Props {
  agreement?: GetExtraWorkAgreementQueryResponse;
  disabled: boolean;
  register: UseFormRegister<ExtraWorkAgreementFormData>;
  setValue: UseFormSetValue<ExtraWorkAgreementFormData>;
  getValue: UseFormGetValues<ExtraWorkAgreementFormData>;
  editPageState: "edit" | "view";
}

export const EditExtraWorkAgreementNumber = (props: Props) => {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(!!props.agreement?.extraWorkAgreementNumber);

  const onCheckChange = () => {
    const newCheckedState = !isChecked;
    setIsChecked(newCheckedState);

    // Clear the field value when unchecking
    if (!newCheckedState) {
      props.setValue("extraWorkAgreementNumber", "", {
        shouldDirty: true,
      });
    }
  };

  useEffect(() => {
    // If disabled, set the checkbox state based on whether there is a number
    if (props.disabled) {
      setIsChecked(!!props.agreement?.extraWorkAgreementNumber);

    }
  }, [props.disabled, props.agreement]);



  return (
    <InputContainer display={"flex"}>
      <Box sx={{ display: "flex" }} gap={1} flexDirection={"column"} alignItems={"flex-end"} >
        <Typography variant="caption" color={"primary.main"}>
          {props.disabled ? t("dashboard.extraWorkAgreements.create.number.labelEdit") : t("dashboard.extraWorkAgreements.create.number.addRefferenceNumber")}
        </Typography>

        <Box flexDirection={"row"} gap={1} sx={{ display: "flex" }}>
          {props.editPageState == "edit" && (
            <Checkbox checked={isChecked} onChange={onCheckChange} disabled={props.disabled} sx={{ padding: "0px" }} size="small"></Checkbox>
          )}
          {props.disabled ? (
            isChecked && (
              <Typography variant="body1" display="flex" alignSelf={"flex-end"}>
                {props.agreement?.extraWorkAgreementNumber}
              </Typography>
            )
          ) : (
            <TextField
              {...props.register("extraWorkAgreementNumber")}
              disabled={props.disabled}
              size="small"
              sx={{ width: "auto", maxWidth: "12ch", display: isChecked ? "block" : "none", fontSize: "12px" }}
              inputProps={{ maxLength: 6 }}
              label={t("dashboard.extraWorkAgreements.create.number.input")}
            />
          )}
        </Box>
      </Box>
    </InputContainer>
  );
};
